export const LOGIN = 'app/LOGIN';
export const LOGIN_FAILURE = 'app/LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'app/LOGIN_SUCCESS';
export const SEND_OTP = 'app/SEND_OTP';

export const CHANGE_PASSWORD = 'app/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'app/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'app/CHANGE_PASSWORD_FAILURE';
